import React, { useMemo, useState } from 'react';
import GeoBrandLogo from './GeoBrandLogo';
import GeoSentimentPill from './GeoSentimentPill';
import GeoMetricTitle from './GeoMetricTitle';
import { formatCompanyName } from '../utils/geoPresentation';
import { getGeoBrandColor } from '../utils/geoBrandColors';

const PAGE_SIZE = 8;

export default function GeoBrandRankingTable({ rows = [], loading = false }) {
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const pageRows = useMemo(() => {
    const start = (page - 1) * PAGE_SIZE;
    return rows.slice(start, start + PAGE_SIZE);
  }, [page, rows]);

  React.useEffect(() => {
    setPage(1);
  }, [rows.length]);

  return (
    <div className="report-card volume-chart-panel geo-insights-table-card geo-insights-ranking-card">
      <div className="chart-panel__header">
        <GeoMetricTitle metricKey="company_ranking">Company Ranking</GeoMetricTitle>
      </div>
      <div className="geo-insights-table-wrap">
        <table className="sec-filing-insights-data-table geo-insights-data-table geo-insights-ranking-table">
          <thead>
            <tr>
              <th className="col-rank">#</th>
              <th className="col-name">Name</th>
              <th className="col-sentiment">Sentiment</th>
              <th className="col-mentions">Mentions</th>
              <th className="col-coverage">Mention share</th>
              <th className="col-sov">SOV</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6}>Loading…</td>
              </tr>
            ) : pageRows.length === 0 ? (
              <tr>
                <td colSpan={6}>No company data in this range</td>
              </tr>
            ) : (
              pageRows.map((row, index) => {
                const displayName = formatCompanyName(row.brand);
                return (
                  <tr
                    key={row.brand}
                    className={row.isClient ? 'geo-insights-row--client' : ''}
                    style={{ '--table-row-delay': index }}
                  >
                    <td className="col-rank">{row.rank}</td>
                    <td className="col-name">
                      <span className="geo-brand-name-cell">
                        <GeoBrandLogo
                          name={displayName}
                          color={getGeoBrandColor(row.rank - 1)}
                          logoUrl={row.logoUrl}
                          isClient={row.isClient}
                        />
                        <span className="geo-brand-name-cell__label" title={displayName}>
                          {displayName}
                        </span>
                      </span>
                    </td>
                    <td className="col-sentiment"><GeoSentimentPill value={row.sentiment} /></td>
                    <td className="col-mentions">{row.mentions}</td>
                    <td className="col-coverage">{row.brandCoverage}%</td>
                    <td className="col-sov">{row.shareOfVoice}%</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {rows.length > PAGE_SIZE ? (
        <div className="geo-insights-pagination">
          <button
            type="button"
            className="btn btn-sm"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ‹
          </button>
          <span>{page}</span>
          <button
            type="button"
            className="btn btn-sm"
            disabled={page >= totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            ›
          </button>
        </div>
      ) : null}
    </div>
  );
}
